import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type {
	RollDetail,
	RollNameOption,
	RollTurn,
} from "../models/RollTurnHistoryDetail";

export const getRollNames = async (
	signal?: AbortSignal,
): Promise<RollNameOption[]> => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2(
		"[ROLLS].[GetRollsPickersDataWeb]",
		[],
		signal,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching roll names");
	}
	const rows = get(resp, "data.tables[0].rows", []) as RollNameOption[];
	// The legacy branch reads a CHAR(12) column, so a short foundry number arrives padded.
	return rows.map((row) => ({ Name: String(row.Name ?? "").trim() }));
};

export const getRollDetail = async (
	rollName: string,
	signal?: AbortSignal,
): Promise<RollDetail | null> => {
	const apiService = new MESApiService();
	// Keyed on the foundry number: the procedure resolves the name to an id.
	const parameters: spParameter[] = [{ name: "RollName", value: rollName }];

	const resp = await apiService.callV2(
		"[ROLLS].[GetRollsDataWeb]",
		parameters,
		signal,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching roll");
	}
	const rows = get(resp, "data.tables[0].rows", []) as RollDetail[];
	return rows.length > 0 ? rows[0] : null;
};

export const getRollTurns = async (
	rollName: string,
	signal?: AbortSignal,
): Promise<RollTurn[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "RollName", value: rollName }];

	const resp = await apiService.callV2(
		"[ROLLS].[GetRollCuts]",
		parameters,
		signal,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching turn history");
	}
	return get(resp, "data.tables[0].rows", []) as RollTurn[];
};
